import { ComponentProps } from "react";

import { DialogPurchase as View } from "./components";
import { ProviderDialogPurchase } from "./context";

type ProviderDialogPurchaseProps = ComponentProps<
  typeof ProviderDialogPurchase
>;

export const DialogPurchase = ({
  onClose,
  open,
  paymentType,
  product,
  productTrial,
  onCreateBill,
  onChangeProduct,
  onSuccess,
  DialogProps,
  redirectDisabled,
  successPageQuery,
}: {
  onClose: () => void;
  open: boolean;
  paymentType?: ProviderDialogPurchaseProps["paymentType"];
  product: ProviderDialogPurchaseProps["product"];
  productTrial?: ProviderDialogPurchaseProps["productTrial"];
  onCreateBill?: ProviderDialogPurchaseProps["onCreateBill"];
  onChangeProduct?: ProviderDialogPurchaseProps["onChangeProduct"];
  onSuccess?: () => void;
  DialogProps?: ComponentProps<typeof View>["DialogProps"];
  redirectDisabled?: ProviderDialogPurchaseProps["redirectDisabled"];
  successPageQuery?: ProviderDialogPurchaseProps["successPageQuery"];
}) => (
  <ProviderDialogPurchase
    paymentType={paymentType}
    product={product}
    productTrial={productTrial}
    onCreateBill={onCreateBill}
    onChangeProduct={onChangeProduct}
    redirectDisabled={redirectDisabled}
    successPageQuery={successPageQuery}
  >
    <View
      onClose={onClose}
      open={open}
      onSuccess={onSuccess}
      DialogProps={DialogProps}
    />
  </ProviderDialogPurchase>
);
